<script setup lang="ts">
import Button from '../components/Button.vue'
import Rialtic from '../logo/Rialtic.vue'

defineProps<{
  actionMessage?: string
  statusCode: number | string
  statusMessage: string
}>()

defineEmits<{
  action: []
}>()
</script>

<template>
  <div>
    <Rialtic class="ml-12 mt-8 block h-10" />
    <div class="text-primary-900 absolute left-2/4 top-52 -translate-x-2/4 p-5">
      <div class="font-display flex flex-col items-center">
        <h1 class="four-oh-four -tracking-4">{{ statusCode }}</h1>
        <div class="mb-12 text-3xl font-light">{{ statusMessage }}</div>
        <Button size="sm" type="button" @click="$emit('action')">
          {{ actionMessage || 'Back to Rialtic app' }}
        </Button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.four-oh-four {
  font-size: 200px;
  line-height: 100%;
}
</style>
